import Page from 'modules/BiomeNutrition'

export default Page

